exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.svg-videocam[data-v-35ac29a1] {\n  width: 30px;\n  height: 30px;\n  display: inline;\n  border: none !important;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n", ""]);

